<div class="container">
    <h1 class="mt120">Contact Us</h1>
    <hr class="mb-0" />
</div>

<div class="mainContnet">
    <div class="container">
        <p>We invite your questions about iTIM and/or how you might implement this powerful equipping program in your
            church. Please use the form below to send us a message, or <a href="#">email us</a></p>

        <div class="col-12 col-md-12 col-lg-4 p-0">
            <form class="contactForm" [formGroup]="formGroup" *ngIf="formGroup">
                <div class="form-group">
                    <label for="">Your Name (required)</label>
                    <input type="text" class="form-control" name="email" placeholder="Your Name" formControlName="name"
                        placeholder="First Name" [class.is-invalid]="isControlInvalid('name')"
                        [class.is-valid]="isControlValid('name')" autocomplete="off" />
                    <h5 class="invalid-feedback" *ngIf="controlHasError('required', 'name')">
                        This field is required
                    </h5>
                    <h5 class="invalid-feedback" *ngIf="controlHasError('maxlength', 'name')">
                        Please enter a value shorter or equal to 50 characters.
                    </h5>
                </div>
                <div class="form-group">
                    <label for="">Your Email (required)</label>
                    <input type="email" class="form-control" id="" placeholder="Your Email" formControlName="email"
                        placeholder="Email" [class.is-invalid]="isControlInvalid('email')"
                        [class.is-valid]="isControlValid('email')" autocomplete="off" />
                    <h5 class="invalid-feedback" *ngIf="controlHasError('required', 'email')">
                        This field is required
                    </h5>
                    <h5 class="invalid-feedback" *ngIf="controlHasError('pattern', 'email')">
                        Please enter a valid email
                    </h5>
                </div>
                <div class="form-group">
                    <label for="">Subject</label>
                    <input type="text" class="form-control" id="" placeholder="Subject" formControlName="phone"
                        placeholder="Subject" [class.is-invalid]="isControlInvalid('phone')"
                        [class.is-valid]="isControlValid('email')" autocomplete="off" />
                    <h5 class="invalid-feedback" *ngIf="controlHasError('maxlength', 'phone')">
                        Please enter a value shorter or equal to 100 characters.
                    </h5>
                </div>
                <div class="form-group">
                    <label for="">Your Message</label>
                    <textarea class="form-control" id="" rows="3" formControlName="message" placeholder="Message"
                        [class.is-invalid]="isControlInvalid('message')" [class.is-valid]="isControlValid('message')"
                        autocomplete="off">
                        Your Message</textarea>
                    <h5 class="invalid-feedback" *ngIf="controlHasError('maxlength', 'message')">
                        Please enter a value shorter or equal to 500 characters.
                    </h5>
                </div>
                <button type="submit" class="btn btnPrimary" (click)="save()">Send</button>
            </form>
        </div>
    </div>
    <app-static-footer></app-static-footer>
</div>